<div class="row justify-content-center mt-2 mb-1">
  <!--<p-steps [model]="items" [activeIndex]="step"></p-steps>-->
  <div class="col-md-6">
    <ul id="progressbar">
      <li [ngClass]="{'active': step === 0}">{{'TEXT.DOC-TYPE' | translate}}</li>
      <li [ngClass]="{'active': step === 1}">{{'TEXT.UP-CSV' | translate}}</li>
      <li [ngClass]="{'active': step === 2 || (step === 3 && (isLoading || error_message))}">{{'TEXT.CREATE-FILE' | translate}}</li>
    </ul>
  </div>
</div>

<div *ngIf="step === 0">
  <div class="row justify-content-center">
    <div class="col">

      <h4 class="row header">
        เลือกประเภทเอกสารเพื่อแปลงไฟล์ CSV เป็น XML/PDF
      </h4>

      <div class="row box-parent text-center">
        <div class="col-md-6" *ngFor="let tem of template.get()">
          <div class="type-option" [ngClass]="{'selected-type': selectedDocumentType === tem.type}"
              (click)="selectDocumentType(tem.type)">
            <img src="../../../../assets/images/csv.png" class="mr-4">
            {{ template.getName(tem.type) }}
            <br>
            {{ template.getNameEN(tem.type) }}
          </div>
        </div>
      </div>

      <div class="row header d-none">
        <h4>{{'BILLING.SIGN-DIGITAL' | translate}}</h4>
      </div>

      <div class="row box-parent d-none">
        <div class="upload-border" *ngIf="!isLoading && !signDocResultPath">
          <div class="row">
            <div class="col">
              <div
                ngfDrop
                multiple
                [accept]="supportFormat"
                [maxSize]="52428800"
                [(files)]="fileDocList"
              >
                <div class="inside-text">
                  {{'TEXT.DRAG' | translate}}<br>
                  <br>
                  <div
                    ngfSelect
                    [(files)]="fileDocList"
                    multiple="1"
                    [accept]="supportFormat"
                    [maxSize]="52428800"
                    class="btn btn-dv btn-clean btn-compact"
                  >{{'TEXT.CHOOSE-FILE' | translate}}</div>
                </div>
              </div>
            </div>
            <!--<div class="col-2" >-->
              <!--<p *ngIf="fileDocList.length > 0"> มีทั้งหมด {{ fileDocList.length }} ไฟล์ </p>-->
            <!--</div>-->
          </div>
          <hr *ngIf="fileDocList.length > 0" />
          <div class="m-t-10 row" *ngFor="let file of fileDocList; let fileIndex = index">
            <div class="col">
              <p class="m-0"> {{ file.name }}</p>
            </div>
            <div class="col-auto" style="align-content: center">
              <button type="button" class="btn btn-delete" (click)="removeDocFile(fileIndex)">ลบ</button>
            </div>
          </div>
          <div class="m-t-30" style="text-align: right" *ngIf="fileDocList.length > 0">
            <button class="btn btn-dv w-100" [disabled]="isLoading" (click)="generateDoc()">ตกลง</button>
          </div>
        </div>

        <div *ngIf="isLoading" class="w-100percent text-center m-t-30">
          <p class="m-b-0">
            <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
          </p>
          <div>
            <p>
              {{'TEXT.SIGNING' | translate}}
              <br>
              <!-- <span *ngIf="total_request_count > 0">{{ fileList.length }} / {{ total_request_count }}</span> -->
              <br>
              {{'TEXT.PLS' | translate}}
            </p>
          </div>
        </div>
        <div *ngIf="error_message" class="w-100percent text-center m-t-30">
          <p>
            {{ error_message }}
          </p>
        </div>
        <div *ngIf="signDocResultPath" class="w-100percent text-center m-t-30">
          <div>
            <h3>{{'TEXT.DONE' | translate}}</h3>
          </div>
          <button class="btn btn-dv btn-clean btn-wide" (click)="resetSignDoc()">
            {{'TEXT.TRY-AGAIN' | translate}}
          </button>
          <button class="btn btn-dv btn-wide" (click)="downloadSignedDoc()">
            {{'TEXT.DOWNLOAD' | translate}}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<div *ngIf="step === 1">
  <div class="row justify-content-center">
    <div class="col">
      <h4 class="row header">
         {{'TEXT.CHANGE-DOC' | translate}} - {{ template.getNameTitle(selectedDocumentType) }}
      </h4>

      <div *ngIf="!gettingSummary" class="row box-parent text-center p-t-10">
        <div class="col-12 p-y-10 text-right">
          <p-dropdown [options]="encodingType" [(ngModel)]="encodingSelected" (onChange)="selectEncoding()"></p-dropdown>
        </div>
        <div class="col-12">
          <div class="upload-border">
            <div
              ngfDrop
              [accept]="'.csv'"
              [maxSize]="52428800"
              [(file)]="file"
              (fileChange)="incomingFile($event)"
              *ngIf="!file"
            >
              <div class="inside-text">
                {{'TEXT.DRAG' | translate}}<br>
                {{'TEXT.OR' | translate}}<br>
                <div
                  ngfSelect
                  [(file)]="file"
                  (fileChange)="incomingFile($event)"
                  [accept]="'.csv'"
                  [maxSize]="52428800"
                  class="btn btn-dv btn-clean btn-wide"
                >{{'TEXT.CHOOSE-CSV' | translate}}</div>
              </div>
            </div>
            <!--<div *ngIf="file" class="row align-items-center">-->
              <!--<div class="col">-->
                <!--{{ file.name }}-->
              <!--</div>-->
              <!--<div class="col-auto" style="align-content: center">-->
                <!--<button type="button" class="btn btn-delete" (click)="removeFile()">ลบ</button>-->
              <!--</div>-->
            <!--</div>-->
          </div>
        </div>
        <!--<div class="col-12" *ngIf="fileList.length !== 0">-->
          <!--<div class="scrollable file-list m-t-20">-->
            <!--<table class="table">-->
              <!--<tbody class="no-head">-->
              <!--<tr *ngFor="let file of fileList; let fileIndex = index" [ngClass]="{'table-header': fileIndex === 0}">-->
                <!--<td class="v-middle" *ngFor="let data of file">-->
                  <!--{{ data }}-->
                <!--</td>-->
              <!--</tr>-->
              <!--</tbody>-->
            <!--</table>-->
          <!--</div>-->
        <!--</div>-->
      </div>

      <div class="row box-parent text-center m-t-30" *ngIf="gettingSummary">
        <div class="col text-center">
          <app-loading-spinner [isLoading]="gettingSummary"></app-loading-spinner>
          <p>
            {{'TEXT.CHECK-F' | translate}}
            <br>
            {{'TEXT.PLS' | translate}}
          </p>
        </div>
      </div>

    </div>
  </div>
  <div class="m-t-30 text-center">
    <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="resetAll()">
      <i class="fas fa-chevron-left m-r-5"></i>
      {{'TEXT.BACK' | translate}}
    </button>
    <button class="btn btn-dv btn-wide" (click)="getSummary()" [disabled]="file == null">
      {{'TEXT.NEXT' | translate}}
      <i class="fas fa-chevron-right m-l-5"></i>
    </button>
  </div>
</div>

<div *ngIf="step >= 2">
  <div class="row justify-content-center">
    <div class="col">

      <h4 class="row header">
        {{'TEXT.RESULT' | translate}}
      </h4>

      <div class="row box-parent text-center">
        <div class="col">
          <div class="card-summary">
            <div class="value">{{ totalDocument }} ไฟล์</div>
            {{'TEXT.NO-DOC' | translate}}
          </div>
        </div>
        <div class="col">
          <div class="card-summary">
            <div class="value">{{ totalVat | currency:' ' }} บาท</div>
            {{'TEXT.VALUE-TAX' | translate}}
          </div>
        </div>
        <div class="col">
          <div class="card-summary">
            <div class="value">{{ totalPayment | currency:' ' }} บาท</div>
            {{'TEXT.AMOUNT' | translate}}
          </div>
        </div>
      </div>

      <div class="row box-parent text-center m-t-30" *ngIf="isLoading">
        <div class="col text-center">
          <app-loading-spinner [isLoading]="true"></app-loading-spinner>
          <p>
            {{'TEXT.WAIT-CHANGE-DOC' | translate}}
            <br>
            {{upload_status_message}}
            <br>
            <br>
            {{'TEXT.PLS' | translate}}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="m-t-30 text-center" *ngIf="step !== 3">
    <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="nextStep(0)">
      <i class="fas fa-chevron-left m-r-5"></i>
      {{'TEXT.BACK' | translate}}
    </button>
    <button class="btn btn-dv btn-wide" (click)="generateXML()" [disabled]="isLoading">
      {{'TEXT.CREATE-FILE' | translate}}
    </button>
  </div>

  <div *ngIf="step === 3">
    <div class="row m-t-30 justify-content-center">
      <div class="col">
        <div class="row box-parent" *ngIf="!error_message">
          <div class="col">
            <div class="row">
              <div class="col">
                <h4>{{'TEXT.CD' | translate}}</h4>
              </div>
            </div>

            <app-custom-pagination
              [(currentPage)]="resultCurrentPage"
              [(itemsPerPage)]="taxDataResultItemPerPage"
              [totalItems]="taxDataResultCount"
              [hideItemsPerPage]="true"
              (pageChange)="showUploadCSVResult()"
              *ngIf="totalItems !== 0"
            >
              <div class="col-auto">
                <button type="button" class="btn btn-dv btn-wide" (click)="downloadAll('xml', content2)">
                  {{'TEXT.D-XML' | translate}}
                </button>
                <button type="button" class="btn btn-dv btn-wide" (click)="downloadAll('pdf', content2)">
                  {{'TEXT.D-PDF' | translate}}
                </button>
              </div>
            </app-custom-pagination>

            <div class="row">
              <div class="col scrollable m-t-20" *ngIf="list">
                <table class="table text-center">
                  <thead>
                  <tr>
                    <th>{{'BILLING.SELLER-TAX' | translate}}</th>
                    <th>{{'FILTER.DOCUMENT-NUMBER' | translate}}/th>
                    <th>XML</th>
                    <th>PDF</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let res of list">
                    <td>{{ res.seller_tax_id }}</td>
                    <td>{{ res.header_invoice_number }}</td>
                    <td>
                      <button type="button" class="btn" (click)="downloadFile(res, 'xml')">
                        <img src="../../../../assets/images/xml.png">
                      </button>
                    </td>
                    <td>
                      <button type="button" class="btn" (click)="downloadFile(res, 'pdf')">
                        <img src="../../../../assets/images/pdf.png">
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row box-parent" *ngIf="error_message && isFieldError(error_message)">
          <div class="col">
            <div class="row">
              <div class="col">
                <h4>{{'TAX-B2P.ERROR' | translate}}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col m-t-20">
                <table class="table text-center">
                  <thead>
                  <tr>
                    <th>{{'TEXT.ROW' | translate}}</th>
                    <th class="text-left">ข้อความ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let error of error_message">
                    <td>{{ error.row }}</td>
                    <td class="text-left">
                      <p *ngFor="let value of objectValues(error.message)">{{ value }}</p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center">
              {{'TEXT.NOTICE' | translate}}
            </div>
          </div>
        </div>

        <div *ngIf="error_message && !isFieldError(error_message)" class="text-center">
          <h4>{{'ERROR.TRY-AGAIN' | translate}}</h4>
          <div>{{error_message}}</div>
        </div>
      </div>
    </div>

    <div class="m-t-30 text-center">
      <div class="col text-center">
        <button class="btn btn-dv btn-clean btn-wide" (click)="resetAll()">
          {{ error_message ? getNamebottomback() : getNamebottomtemplate()}}
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip" (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress" height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeDownloadAll()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-upload/document-upload.component.html